import { render, staticRenderFns } from "./VProductionTurnover.vue?vue&type=template&id=66cd86a2&"
import script from "./VProductionTurnover.vue?vue&type=script&lang=js&"
export * from "./VProductionTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports